/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocXIcon16Light } from './DocXIcon16Light';
import { DocXIcon16Regular } from './DocXIcon16Regular';
import { DocXIcon16Solid } from './DocXIcon16Solid';
import { DocXIcon20Light } from './DocXIcon20Light';
import { DocXIcon20Regular } from './DocXIcon20Regular';
import { DocXIcon20Solid } from './DocXIcon20Solid';
import { DocXIcon24Regular } from './DocXIcon24Regular';
import { DocXIcon24Solid } from './DocXIcon24Solid';
import { DocXIcon32Regular } from './DocXIcon32Regular';
import { DocXIcon64Regular } from './DocXIcon64Regular';
var sizes = {
    16: {
        light: DocXIcon16Light,
        regular: DocXIcon16Regular,
        solid: DocXIcon16Solid,
    },
    20: {
        light: DocXIcon20Light,
        regular: DocXIcon20Regular,
        solid: DocXIcon20Solid,
    },
    24: {
        regular: DocXIcon24Regular,
        solid: DocXIcon24Solid,
    },
    32: {
        regular: DocXIcon32Regular,
    },
    64: {
        regular: DocXIcon64Regular,
    },
};
export var DocXIcon = forwardRef('DocXIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
